var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.surveyId)?_c('div',{attrs:{"id":"survey"}},[_vm._m(0)]):_c('div',{staticClass:"survey-info"},[_c('h1',[_vm._v("\n    No survey available.\n  ")]),_vm._v("\n  Thank you for your interest in providing feedback. Please check back again to participate.\n")])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"survey-info"},[_c('h1',[_vm._v("\n      Loading survey...\n    ")])])
}]

export { render, staticRenderFns }